import { createSlice } from "@reduxjs/toolkit";
import { fetchfetchStock } from "./thunk";

interface StockState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: StockState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const Stockslice = createSlice({
  name: "Stock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchfetchStock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchfetchStock.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchfetchStock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export default Stockslice.reducer;
